// usePhoneDrawer: on a phone the open drawer lies over the page (styles.css),
// so once used it gets out of the way. Escape shuts it, and so does a pick in
// it: a control marked data-drawer-pick, one that changes what the page shows.
// A tap on the scrim beside it shuts it too (the shell's). Returns the
// drawer's click handler.
import { useEffect } from "react";
import { isMobileViewport } from "./shell.js";

export function usePhoneDrawer(collapsed, setCollapsed) {
  useEffect(() => {
    if (collapsed) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !e.defaultPrevented && isMobileViewport()) setCollapsed(true);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [collapsed, setCollapsed]);
  return (e) => {
    if (isMobileViewport() && e.target.closest("[data-drawer-pick]")) setCollapsed(true);
  };
}
